
import PropTypes from 'prop-types';
import React, { useEffect, useState } from "react";
import { message, Spin, Empty, Row, Col } from "antd";
import { UserCenterCard } from '../Pages/GlobalComponents/UserCardCmnts'
import { FetchUserDetails } from "../../../Api/Services/UserApiService"

const NoteDetails = ({ displayData, refreshTrigger, tabKey }) => {
    const [followersUser, setFollowersUser] = useState([])
    async function getUsersData1(params) {
        try {
            const competitionArray = params.split(',').map(item => Number(item.trim()));
            const results = await Promise.all(
                competitionArray.map(async (competitionId) => {
                    const Response = await FetchUserDetails(competitionId)
                    return Response?.data;
                })
            );
            setFollowersUser(results);
        } catch (error) {
            message.error(error);
        }
    }
    useEffect(() => {
        if (displayData?.followers) {
            if (refreshTrigger === tabKey) {
                getUsersData1(displayData?.followers)
            }
        }
    }, [displayData, refreshTrigger, tabKey])
    return (
        <>
            <Row gutter={30}>
                {followersUser ? (followersUser?.length > 0 ?
                    followersUser?.map((item, index) => {
                        return (
                            <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                                <UserCenterCard item={item} index={index} />
                            </Col>
                        )
                    }) :
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                        <div style={{ padding: "10%" }}>
                            <Empty />
                        </div></Col>)
                    :
                    <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                        <div className="spin">
                            <Spin />
                        </div></Col>
                }
            </Row >
        </>
    );
};
NoteDetails.propTypes = {
    displayData: PropTypes.object.isRequired,
    refreshTrigger: PropTypes.string.isRequired,
    tabKey: PropTypes.string.isRequired,
};
export default React.memo(NoteDetails)
